import GetProductCategoriesRequestModelBase from '../_generated/modelBases/get-product-categories-request-model-base';

export default class GetProductCategoriesRequestModel extends GetProductCategoriesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
